import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Avatar from './components/AvatarDropdown';
import styles from './index.module.less';
import { BroadcastChannel } from 'broadcast-channel';
import { HeaderRight } from './components/HeaderRight';
import HeaderTabs from './components/HeaderTabs';
import React, { useEffect, useMemo, useState } from 'react';
import { request } from '@/shared/io';
import { get, isEmpty } from 'lodash-es';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Modal } from 'antd';
import { getApiUrl } from '@/shared/utils';
import companyDefaultLogo from '@/shared/assets/png/companyDefaultLogo.png';
import { AddCompanyDrawer } from '@/shared/system/uims/AddCompanyDrawer';
import { useSharedGlobalState } from '@/shared/hooks';
import { useSystemName } from '../hooks';
const changeNameBc = new BroadcastChannel('changeNameBc');
const SYSTRM_NAME_KEY = '__system_name';
const getSystemNameFromSession = () => {
    return sessionStorage.getItem(SYSTRM_NAME_KEY);
};
const setSystemNameFromSession = (str) => {
    return sessionStorage.setItem(SYSTRM_NAME_KEY, str);
};
export const KxHeader = ({ canChangeCompany = false, headerTabs = [], hasBase = true, isBodySrcoll }) => {
    const [addDrawerVisible, setAddDrawerVisible] = useState(false);
    const { authLoginType, orgMyUserInfoType: avatarUrl, _initStateByKey } = useSharedGlobalState();
    const [userCompany, setUserCompany] = useState([]);
    const [renderFlag, setRenderFlag] = useState(Math.random());
    const [systemName, setSystemName] = useState('');
    const curUserInfo = useMemo(() => {
        const _userInfoStr = sessionStorage.getItem('USER_INFO') || '{}';
        const _userInfo = JSON.parse(_userInfoStr);
        return _userInfo;
    }, [renderFlag]);
    const ptZhName = useSystemName(authLoginType);
    useEffect(() => {
        if (curUserInfo.companyName) {
            // getMyMessage().then((res: myMessageModel.RootObject) => {
            //   if (res && res.code == 200) {
            //     setMyMessage(res.data);
            //   }
            // });
            request('/api/uims/v1/org/user/company').then((res) => {
                if (res && res.code == 200) {
                    setUserCompany(res.data);
                }
            });
        }
    }, [curUserInfo.companyName, renderFlag]);
    useEffect(() => {
        changeNameBc.addEventListener('message', () => {
            setRenderFlag(Math.random());
        });
    }, []);
    useEffect(() => {
        request(`${getApiUrl(authLoginType)}/api/uims/v1/org/my`).then(({ code, data }) => {
            if (code === 200) {
                _initStateByKey('orgMyUserInfoType', data);
            }
        });
    }, [renderFlag]);
    const authImgSrc = useMemo(() => {
        if (!curUserInfo || !userCompany) {
            return '';
        }
        const userCompId = curUserInfo.defaultCompId;
        const userComp = userCompany.find((c) => c.companyId == userCompId);
        if (!userComp) {
            return '';
        }
        const certificationStatus = get(userComp, 'isAuth', '');
        if (certificationStatus == '0') {
            return '/public/website/scm/auth0.svg';
        }
        if (certificationStatus == '3') {
            return '/public/website/scm/auth3.svg';
        }
        if (certificationStatus == '1' || certificationStatus == '2') {
            return '/public/website/scm/auth12.svg';
        }
        return '';
    }, [curUserInfo, userCompany]);
    const menuItems = useMemo(() => {
        if (!userCompany || !userCompany.length) {
            return [];
        }
        // const curComId = get(myMessage, 'company.id', '');
        return userCompany.map((c) => {
            return {
                key: c.companyId,
                label: c.companyName,
                disabled: c.companyId == curUserInfo.defaultCompId,
                onClick: () => {
                    const content = '请确保您的正在操作的数据已经被妥善保存。刷新后仅保留当前页面，其他页面将被关闭';
                    Modal.confirm({
                        title: '确认切换企业并刷新',
                        cancelText: '取消',
                        okText: '刷新',
                        onOk() {
                            request('/api/uims/v1/org/default/company', {
                                method: 'PUT',
                                data: {
                                    companyName: c.companyName,
                                    companyId: c.companyId,
                                },
                            }).then((res) => {
                                if (res && res.code == 200) {
                                    window.sessionStorage.setItem('noclose', 'noclose');
                                    window.location.reload();
                                }
                            });
                        },
                    });
                    // confirm({
                    //   title: '确认切换企业并刷新',
                    //   cancelText: '取消',
                    //   okText: '刷新',
                    //   content: content,
                    //   onOk() {
                    //     putChangeCompany({
                    //       companyName: c.companyName,
                    //       companyId: c.companyId,
                    //     }).then((res: putChangeCompRes.RootObject) => {
                    //       if (res && res.code == 200) {
                    //         window.sessionStorage.setItem('noclose', 'noclose')
                    //         window.location.reload();
                    //       }
                    //     });
                    //   },
                    // });
                },
            };
        });
    }, [userCompany]);
    const systemMenu = [{ label: ptZhName, key: '/portal' },
        { label: '消息通知', key: '/message/' }];
    const onClickSystemItem = (item) => {
        console.log('-----ssss');
        console.log(item);
        window.location.href = item.key;
        setSystemName(item.label);
    };
    const menu = (_jsx(Menu, { style: {
            maxHeight: '600px',
            overflow: 'hidden',
            overflowY: 'auto',
        }, items: [
            ...menuItems,
            // {
            //   key: 'addItem',
            //   label: (
            //     <span
            //       style={{
            //         color: '#1677FF',
            //       }}
            //     >
            //       添加企业
            //     </span>
            //   ),
            //   icon: (
            //     <PlusOutlined
            //       style={{
            //         color: '#1677FF',
            //       }}
            //     />
            //   ),
            //   onClick: () => {
            //     setAddDrawerVisible(true);
            //   },
            // },
        ] }));
    const companyAvatarSrc = useMemo(() => {
        const fileSrcUrl = get(avatarUrl, 'company.logoFile.fileSrcUrl', '');
        if (!avatarUrl || !fileSrcUrl) {
            //src\assets\img\companyDefaultLogo.png
            return companyDefaultLogo;
        }
        return fileSrcUrl;
    }, [avatarUrl]);
    if (!curUserInfo) {
        return null;
    }
    return (_jsxs("header", { className: isBodySrcoll ? styles['scroll-header'] : styles.header, children: [_jsx("div", { className: styles.headerLeft, children: curUserInfo.companyName ? _jsxs(React.Fragment, { children: [_jsx("img", { src: companyAvatarSrc, height: "28px", style: {
                                borderRadius: '50%',
                                width: '32px',
                                height: '32px',
                                marginLeft: '8px',
                            } }), authImgSrc && (_jsx("img", { className: styles.authImg, src: `${getApiUrl()}${authImgSrc}`, alt: "" })), _jsxs("div", { className: styles.headerCompWrap, children: [_jsx("div", { className: styles.headerComp, children: curUserInfo.companyName }), canChangeCompany ? (_jsx(Dropdown, { overlayClassName: 'lj-company-down', destroyPopupOnHide: true, overlay: menu, placement: "bottomLeft", children: _jsx("a", { onClick: (e) => e.preventDefault(), children: _jsx(DownOutlined, { style: {
                                                marginLeft: '8px',
                                                marginTop: '4px',
                                                color: '#fff',
                                                fontSize: '13px',
                                            } }) }) })) : null, _jsx("span", { className: `${styles['system-name-scm']}`, children: systemName || ptZhName }), _jsx(Dropdown, { overlayClassName: 'lj-company-down', destroyPopupOnHide: true, menu: { items: systemMenu, onClick: onClickSystemItem }, placement: "bottomRight", children: _jsx("a", { onClick: (e) => e.preventDefault(), children: _jsx(DownOutlined, { style: {
                                                marginLeft: '8px',
                                                marginTop: '4px',
                                                color: '#fff',
                                                fontSize: '13px',
                                            } }) }) })] })] }) : _jsx("div", { className: styles.headerCompWrap, children: _jsx("span", { className: `${styles['system-name-scm']}`, children: ptZhName }) }) }), !isEmpty(headerTabs) ? _jsx(HeaderTabs, { headerTabs: headerTabs }) : null, _jsxs("div", { style: { height: 48, display: 'flex', alignItems: 'center' }, children: [_jsx(HeaderRight, { hasBase: hasBase }), _jsx(Avatar, { showMenu: true })] }), addDrawerVisible && (_jsx(AddCompanyDrawer, { visible: addDrawerVisible, onCancel: () => setAddDrawerVisible(false) }))] }));
};
